"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ComponentActionHandler", {
  enumerable: true,
  get: function () {
    return _ComponentActionHandler.default;
  }
});
Object.defineProperty(exports, "HotAreaActionHandler", {
  enumerable: true,
  get: function () {
    return _HotAreaActionHandler.default;
  }
});

var _ComponentActionHandler = _interopRequireDefault(require("./ComponentActionHandler.vue"));

var _HotAreaActionHandler = _interopRequireDefault(require("./HotAreaActionHandler.vue"));

if (!process.env.SSR) {
  require('intersection-observer-polyfill/index.global'); //eslint-disable-line

}